import wx from 'weixin-js-sdk'
import { DATA } from '../data'
import { WEIXIN_BASE } from './base'
import { WEIXIN_CHAT } from './chat'
import { WEIXIN_PAY } from './pay'

//需在用户可能点击分享按钮前就先调用
var WEIXIN = {
    /**
     * 微信分享配置
     */
    initConfigShare(sucFunc, failFunc) {
        var curPath = AppFate.$router.history.current.path,
            userInfo = AppFate.$store.state.userData,
            detailData = AppFate.$store.state.detail,
            commentData = AppFate.$store.state.comment,
            discussData = AppFate.$store.state.discuss,
            otherShareData = AppFate.$store.state.othershare,
            donateData = AppFate.$store.state.donate,
            famouspediaData = AppFate.$store.state.famouspedia;

        WEIXIN_BASE.getAuthorationAndConfigJsSDK(function(){
            
            // 处理分享参数
            var baseTitle = '木火通明八字', hideName = false, newTitle = '', shareId = '';
            var WxShareData = {
                title: baseTitle,
                desc: '专业好用的八字软件；支持手机和电脑使用；让易学数据世代相传。',
                linkurl: 'https://' + location.hostname,
                img: 'https://' + location.hostname + '/dist/logo.png',
            }
            
            document.title = baseTitle;
            // console.log('shareconfig========path', curPath, detailData.personInfo, userInfo)

            // 处理命盘分享参数
            if (curPath.indexOf('detail') != -1 && detailData.personInfo.birthday) {
                hideName = detailData.personInfo.f_name == '匿名' || detailData.hideName ? true : false;
                newTitle = DATA.getSharedTextByData('wechat', hideName, detailData.personInfo);
                document.title = newTitle;
                WxShareData.title = newTitle;
                WxShareData.desc = '点击可选择保存新八字。打开后点击右上角"..."选择"浮窗"可锁定八字防刷屏.支持多八字对比';
                shareId = hideName ? detailData.personInfo.share : detailData.personInfo.share2;
                WxShareData.linkurl = 'https://' + location.hostname + '/share/detail/' + shareId + '-save0';
            }

            // 处理批盘分享参数:自己的批盘
            if (curPath.indexOf('comment/detail') != -1 && detailData.personInfo.id) {
                document.title = '我的批盘';
                WxShareData.title = DATA.getPipanSharedTextByData('wechat', userInfo, detailData.personInfo);;
                WxShareData.desc = '点击查看批盘内容。打开后可点击右上角『保存』将批盘内容保存到我的八字库中。';
                shareId = commentData.hideName ? commentData.shareCode.nmpishare : commentData.shareCode.smpishare;
                WxShareData.linkurl = 'https://' + location.hostname + '/share/comment/' + shareId;
                WxShareData.img = 'https://' + location.hostname + '/dist/share-img-2.png';
            }

            // 处理批盘分享参数:他人的批盘
            if(curPath.indexOf('comment/othercomment') != -1 && detailData.personInfo.id) {
                document.title = commentData.otherShareTitle;
                WxShareData.title = DATA.getOtherPipanShareTextByData('wechat', commentData.otherShareTitle, detailData.personInfo);
                WxShareData.desc = '点击查看批盘内容。打开后可点击右上角『保存』将批盘内容保存到我的八字库中。';
                shareId = commentData.hideName ? commentData.otherShareCode.nmothershare : commentData.otherShareCode.smothershare;
                WxShareData.linkurl = 'https://' + location.hostname + '/share/comment/' + shareId;
                WxShareData.img = 'https://' + location.hostname + '/dist/share-img-2.png';
            }

            // 处理批盘分享参数:二次转发分享页面
            if(curPath.indexOf('share/comment') != -1 && detailData.personInfo) {
                document.title = otherShareData.shareTitle;
                WxShareData.title = DATA.getOtherPipanShareTextByData('wechat', otherShareData.shareTitle, detailData.personInfo);
                WxShareData.desc = '点击查看批盘内容。打开后可点击右上角『保存』将批盘内容保存到我的八字库中。';
                shareId = otherShareData.shareId;
                WxShareData.linkurl = 'https://' + location.hostname + '/share/comment/' + otherShareData.shareId;
                WxShareData.img = 'https://' + location.hostname + '/dist/share-img-2.png';
            }

            // 处理论盘分享参数
            if(curPath.indexOf('discuss/') != -1 && detailData.personInfo) {
                document.title = discussData.lunpanData.title;
                WxShareData.title = DATA.getLunPanShareTextByData('wechat', discussData.lunpanData.title, detailData.personInfo);
                WxShareData.desc = '点击进入在线论盘，论盘记录将永久保存在对应八字下面的论盘记录中，可随时查阅。';
                shareId = discussData.hideName ? discussData.lunpanData.shareCode.nmlpshare : discussData.lunpanData.shareCode.smlpshare;
                WxShareData.linkurl = 'https://' + location.hostname + '/share/discuss/' + shareId;
                WxShareData.img = 'https://' + location.hostname + '/dist/share-img-3.png';
            }

            // 处理捐赠页面分享参数
            if(curPath.indexOf('donate') != -1) {
                var donateTitle = donateData && donateData.myNum && donateData.myNum != 0 ? 
                    ('助力传统文化复兴，我是第' + donateData.myNum + '位文化复兴大使！') :
                    '助力传统文化复兴，我来点燃星火！';
                document.title = donateTitle;
                WxShareData.title = donateTitle;
                WxShareData.desc = '文化复兴，功在当代，利在千秋。';
                WxShareData.linkurl = 'https://' + location.hostname + '/donate';
                WxShareData.img = 'https://' + location.hostname + '/dist/share-img-4.png';
            }

            // 处理异常情况:恢复成默认的情况
            if(!shareId){
                WxShareData.title = baseTitle;
                WxShareData.desc = '专业好用的八字软件；支持手机和电脑使用；让易学数据世代相传。';
                WxShareData.linkurl = 'https://' + location.hostname;
                WxShareData.img = 'https://' + location.hostname + '/dist/logo.png';
            }

            // 导入页面
            if(curPath.indexOf('import') != -1) {
                WxShareData.linkurl = 'https://' + location.hostname + '/import';
            }
            
            // 处理百科页面分享参数
            if(curPath.indexOf('famouspedia') != -1) {
                var famousTitle = '名人八字百科',
                    famousUrl = 'https://' + location.hostname + '/famouspedia';
                if(curPath.indexOf('/famouspediaread') != -1) {
                    var famousBaziInfo = famouspediaData.curPediaBaziInfo;
                    famousTitle = famousBaziInfo ? DATA.getFamousPediaShareTextByData('wechat', famousBaziInfo) : famousTitle;
                    famousUrl = famousBaziInfo ? 'https://' + location.hostname + '/share/famouspediaread/' + famousBaziInfo.id + '/famouspedia' : famousUrl;
                }
                document.title = famousTitle;
                WxShareData.title = famousTitle;
                WxShareData.desc = '点击可查看名人生平事迹及与之对应的各位易友的论断。';
                WxShareData.linkurl = famousUrl;
                WxShareData.img = 'https://' + location.hostname + '/dist/share-img-5.png';
                console.log('famouspedia-----initConfigShare', curPath, famousBaziInfo)
            }

            console.log("getWeixinSdkConfig----配置成功", WxShareData);

            // 页面加载完成后用户就有可能调用微信的分享，所以当页面ready 完后就加载
            wx.ready(function () {
                var commonShareData = {
                    // 分享标题
                    title: WxShareData.title,
                    // 分享描述
                    desc: WxShareData.desc,
                    // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                    link: WxShareData.linkurl,
                    // 分享图标
                    imgUrl: WxShareData.img,
                    success: function () {
                        console.log('分享回调函数');
                        if(sucFunc && typeof(sucFunc) == 'function'){
                            sucFunc();
                        }
                    },
                }
                wx.onMenuShareTimeline(commonShareData);//1.0
                wx.updateTimelineShareData(commonShareData);//1.0
                wx.onMenuShareAppMessage(commonShareData)//1.4
                wx.updateAppMessageShareData(commonShareData)//1.4
            });

            // 微信预加载失败回调
            wx.error(function (res) {
                console.error(res);
                if(failFunc && typeof(failFunc) == 'function'){
                    failFunc();
                }
            });
        });
    }
}

export {
    WEIXIN, WEIXIN_CHAT, WEIXIN_PAY
}